import {DDR} from './ddr.class';

export class DDRLactatingMother18Strategy extends DDR {
  constructor() {
    super([1200, 5, 19, 75, 115, 1.4, 1.6, 17, 2, 500, 2.8, 7, 35, 550, 1300, 44, 1300, 3, 290, 10, 360, 2.6, 1250, 70, 14]);
  }
}
